/**
 * `loader` de Operaciones · Ventas — ADR-0012, paso 2, mitad 2.
 *
 * Segunda ruta con `loader`. El RUM la señaló como **la más lenta del panel**: p75 1.810 ms con 57%
 * de caché, sobre 7 navegaciones reales. El orden lo dicta la medición, no la intuición.
 *
 * El porqué de cada decisión está explicado una sola vez, en `./productos.ts`: `ensureQueryData` y no
 * `fetchQuery`, no esperar la promesa, una única definición de la consulta compartida con la
 * pantalla, y de dónde sale el tenant fuera de React.
 */

import { opcionesPedidosOps } from '@/pages/operaciones/opsOrdersQuery';
import { queryClient } from '@/lib/queryClient';
import { tenantDelPanel } from './tenantDelPanel';

/**
 * La vista con la que abre Ventas. Espeja el estado inicial de `OperationsOrdersView`
 * (`VARIANTS.ventas`): vista «Todos», sin filtros, 25 por página.
 *
 * 🪤 `stages` y `sort` NO se inventan acá: si se desincronizan de `VARIANTS.ventas`, el loader
 * calienta una entrada que la pantalla no lee y el usuario paga dos consultas. Cuando cambien allá,
 * cambian acá — están a un `grep VARIANTS` de distancia y el comentario lo dice para que se busque.
 */
const VISTA_INICIAL = {
  stages: ['sale', 'fulfilled', 'closed'] as const,
  search: '',
  paymentStatus: [] as string[],
  shippingStatus: [] as string[],
  channel: [] as string[],
  billingStatus: [] as string[],
  onlyWithDue: undefined,
  sort: 'created_at desc',
  offset: 0,
  pageSize: 25,
};

export function cargarOpsVentas() {
  const tenantId = tenantDelPanel();
  if (!tenantId) return null;

  // 🚨 `void` + `return null`: se dispara la carga y NO se la espera. React Router ESPERA el valor
  // que devuelve el loader, así que devolver la promesa congelaba la navegación — el usuario se
  // quedaba en la pantalla anterior. Ver el porqué completo en `./productos.ts`.
  void queryClient
    .ensureQueryData(
      opcionesPedidosOps({
        tenantId,
        ...VISTA_INICIAL,
        stages: [...VISTA_INICIAL.stages],
      } as Parameters<typeof opcionesPedidosOps>[0]),
    )
    .catch(() => {});
  return null;
}
